<template>
<div class="chapter">
<div class="inner_page">
<p class="C152"><a id="page_2">By way of introduction . . .</a></p><a id="page_2">
<p class="C154">To encounter the quantum is to feel like an explorer from a faraway land who has come for the first time upon an automobile. It is obviously meant for use, and important use, but what use?</p>
<p class="C155" style="text-align:right;">John Archibald Wheeler</p>
<p class="C154">Somewhere in [quantum theory] the distinction between reality and our knowledge of reality has become lost, and the result has more the character of medieval necromancy than of science.</p>
<p class="C155" style="text-align:right;">Edwin Jaynes</p>
<p class="C154">We must never forget that ‘reality’ too is a human word just like ‘wave’ or ‘consciousness’. Our task is to learn to use these words correctly – that is, unambiguously and consistently.</p>
<p class="C155" style="text-align:right;">Niels Bohr</p>
</a><p class="C154"><a id="page_2">[</a><a id="page_3">Quantum mechanics] is a peculiar mixture describing in part realities of Nature, in part incomplete human information about Nature – all scrambled up by Heisenberg and Bohr into an omelette that nobody has seen how to unscramble.</a></p><a id="page_3">
<p class="C155" style="text-align:right;">Edwin Jaynes</p>
<p class="C154">Arguably the most important lesson of quantum mechanics is that we need to critically revisit our most basic assumptions about nature.</p>
<p class="C155" style="text-align:right;">Yakir Aharonov et al.</p>
<p class="C154">I hope you can accept Nature as she is – absurd.</p>
<p class="C156" style="text-align:right;">Richard Feynman</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_By_way_of_introduction.vue?830d7508